import { render, staticRenderFns } from "./processSafetyReport.vue?vue&type=template&id=962055fa"
import script from "./processSafetyReport.vue?vue&type=script&lang=js"
export * from "./processSafetyReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('962055fa')) {
      api.createRecord('962055fa', component.options)
    } else {
      api.reload('962055fa', component.options)
    }
    module.hot.accept("./processSafetyReport.vue?vue&type=template&id=962055fa", function () {
      api.rerender('962055fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/opm/processSafetyReport.vue"
export default component.exports